import ABOUT_TEAM_EXPERTS from "../../images/paywall-about-team-experts.png"
import ABOUT_ADVICE from "../../images/paywall-about-landowners-advice.png"
import FOUNDERS from "../../images/paywall-about-zack-max.png"

import AboutNCXTextSection from "./AboutNCXTextSection"

const PaywallAboutNCX = () => (
  <div
    className="container max-w-[1440px] md:bg-white bg-sand w-full p-0 md:px-12 lg:px-16 xxl:px-18 md:pb-18 lg:pb-28"
    data-testid="paywall-about-ncx"
  >
    <div className="bg-white pt-[62px] lg:pt-[66px] pb-14 lg:pb-[58px]">
      <h1
        className="text-3xl md:text-4xl text-center font-display font-medium leading-[124%] tracking-[0.6px] md:tracking-[0.72px]"
        data-testid="paywall-about-ncx-heading"
      >
        About NCX
      </h1>
    </div>

    <div className="md:grid lg:grid-rows-3 md:gap-9">
      <AboutNCXTextSection
        headline="A team of experts working with you"
        subheading="At NCX, we believe that every landowner in America deserves access to personal advisors to help navigate the complexity of forest ownership."
        body="We use technology to keep prices low and NCX membership as accessible as possible for the millions of family forest owners across the country. When you become an NCX Member, your personal advisor coordinates with NCX's nationwide team of foresters, satellite imagery and mapping experts, computer engineers, and accountants dedicated to helping you manage your land with confidence."
        imageSrc={ABOUT_TEAM_EXPERTS}
      />

      <AboutNCXTextSection
        headline="Landowners are #1 at NCX"
        subheading="Honest and unbiased advice."
        body="NCX is funded through membership fees. Unlike other companies, NCX avoids conflicts of interest by not taking commissions or lead fees from project developers, timber buyers, or realtors. We understand that your land is a precious asset and you don't want to make the wrong decisions for future generations. As an NCX Member, you can be confident that you are our top priority and your interests come first."
        imageSrc={ABOUT_ADVICE}
      />

      <AboutNCXTextSection
        headline="Committed to your best long-term decisions"
        subheading="You're in it for the long haul. So are we."
        body="NCX founders Max and Zack started the company 15 years ago to help landowners make better forest management decisions with better data. Land ownership is a long-term commitment and NCX is committed to your long-term success. Your membership allows us to constantly reinvest in new data, features, and analysis, making NCX the place landowners go when they want to make informed and confident decisions about their land."
        imageSrc={FOUNDERS}
      />
    </div>
  </div>
)

export default PaywallAboutNCX
